import React, { useEffect } from 'react';
import { CoachCard } from '../components/CoachCard';
import { CTABand } from '../components/CTABand';
export function About() {
  useEffect(() => {
    document.title = 'Meet the Coaches | Storm Taekwondo';
  }, []);
  const coaches = [{
    name: 'Shane Merem',
    role: 'Owner / Team Storm Coach',
    bio: 'Coach Shane instills grit, confidence, determination, and discipline in every student. He focuses on physical fitness and building strong character both on and off the mat.',
    imageUrl: 'https://images.unsplash.com/photo-1591117207239-788bf8de6c3b?auto=format&fit=crop&w=800&q=80'
  }, {
    name: 'Megan Merem',
    role: 'Chief Instructor',
    bio: 'A two-time USA National Sparring Champion who has been training since age 3. Coach Megan creates a friendly but firm learning environment where students thrive.',
    imageUrl: 'https://images.unsplash.com/photo-1555597673-b21d5c935865?auto=format&fit=crop&w=800&q=80'
  }, {
    name: 'Michael Jacobs',
    role: 'Instructor',
    bio: 'A USAT National Gold Medalist, Coach Michael brings high-level competitive experience and technical precision to his classes.',
    imageUrl: 'https://images.unsplash.com/photo-1544117519-31a4b719223d?auto=format&fit=crop&w=800&q=80'
  }, {
    name: 'Russ Gale',
    role: 'Strength & Conditioning',
    bio: 'A high-level strength and conditioning coach connected with the Team USA coaching staff, ensuring our athletes are physically prepared for any challenge.',
    imageUrl: 'https://images.unsplash.com/photo-1599058917212-d750089bc07e?auto=format&fit=crop&w=800&q=80'
  }, {
    name: 'Ryder Jacobs',
    role: 'Instructor / Team Storm Athlete',
    bio: 'As both an active Team Storm athlete and instructor, Coach Ryder relates well to younger students and leads by example through hard work.',
    imageUrl: 'https://images.unsplash.com/photo-1517438476312-10d79c077509?auto=format&fit=crop&w=800&q=80'
  }];
  return <div className="flex flex-col bg-off-white" data-id="element-432">
      {/* Hero */}
      <section className="bg-ink py-20 text-center px-4" data-id="element-433">
        <h1 className="text-5xl md:text-6xl text-white mb-6" data-id="element-434">
          Meet the Storm Coaching Team
        </h1>
        <p className="text-xl text-gray-warm max-w-2xl mx-auto" data-id="element-435">
          Experienced, passionate, and dedicated to helping every student reach
          their full potential.
        </p>
      </section>

      {/* Coaches Grid */}
      <section className="py-24" data-id="element-436">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-437">
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-438">
            {coaches.map((coach, idx) => <CoachCard key={idx} name={coach.name} role={coach.role} bio={coach.bio} imageUrl={coach.imageUrl} data-id="element-439" />)}
          </div>
        </div>
      </section>

      <CTABand headline="Train With the Best" copy="Experience our coaching firsthand. Claim your free week and meet the team." data-id="element-440" />
    </div>;
}